import { useEffect } from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import { applySeo } from "@/lib/seo";

export default function Impressum() {
  useEffect(() => {
    applySeo({
      title: "Impressum – Grüne Geldanlage",
      description: "Impressum und Anbieterkennzeichnung nach § 5 TMG / DDG für das Fachportal Grüne Geldanlage.",
      canonicalPath: "/impressum",
    });
  }, []);
  return (
    <div className="min-h-screen bg-brand-paper" data-testid="impressum-page">
      <Header />
      <section className="max-w-3xl mx-auto px-6 lg:px-10 pt-20 pb-24">
        <div className="overline mb-4">Rechtliches</div>
        <h1 className="font-serif text-5xl font-light leading-tight text-brand-dark mb-10">Impressum</h1>
        <div className="prose-editorial max-w-none">
          <h2>Angaben gemäß § 5 TMG / DDG</h2>
          <p>
            Xolo Go OÜ – Commerce Unlimited<br />
            Markus Gildemeister<br />
            Kalasadama tn 4<br />
            10415 Tallinn<br />
            Estland
          </p>
          <h2>Kontakt</h2>
          <p>
            Telefon: +49 (0)176 65057661<br />
            E-Mail: <a href="mailto:info@gruene-geldanlage.com">info@gruene-geldanlage.com</a>
          </p>
          <h2>Handelsregister</h2>
          <p>
            Registrierungsnummer: <strong>14717109</strong> (Estnisches Handelsregister)
          </p>
          <h2>Umsatzsteuer-Identifikationsnummer</h2>
          <p>
            USt-IdNr. gemäß § 27 a UStG: <strong>EE102156920</strong>
          </p>
          <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
          <p>
            Markus Gildemeister<br />
            c/o Xolo Go OÜ – Commerce Unlimited<br />
            Kalasadama tn 4, 10415 Tallinn, Estland
          </p>
          <h2>Streitschlichtung</h2>
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS)
            bereit: <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr/</a>. Wir sind nicht bereit oder verpflichtet, an
            Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
          </p>
          <h2>Haftungshinweis</h2>
          <p>
            Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die
            Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich
            deren Betreiber verantwortlich.
          </p>
        </div>
      </section>
      <Footer />
    </div>
  );
}
